import React, { useState } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';

const TransferUnsealedToSealed = () => {
    const [scannedData, setScannedData] = useState('');
    const [entries, setEntries] = useState([]);
    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const parseScannedData = (data) => {
        const lines = data.trim().split('\n');

        const parsedEntries = lines.map((line, index) => {
            const parts = line.split(',').map(part => part.trim());
            if (parts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format.`);
            }

            // Product names may contain commas — SKU and BOX/DATE are always the last two parts
            const scannerSet = parts.slice(0, -2).join(', ');
            const sku = parts[parts.length - 2];
            const boxInfoAndDate = parts[parts.length - 1];
            const [scannerNumber, ...setNameParts] = scannerSet.split('-');
            const setName = setNameParts.join('-').trim();

            const boxInfoAndDateParts = boxInfoAndDate.split(' ');
            if (boxInfoAndDateParts.length < 3) {
                throw new Error(`Row ${index + 1}: Incorrect data format BOX/DATA/TIME.`);
            }

            const [boxInfo, date, time] = boxInfoAndDateParts;
            const [boxNumber, quantity] = boxInfo.split('/');

            return {
                scanner: scannerNumber.trim(),
                setName: setName.trim(),
                sku: sku,
                boxNumber: boxNumber.replace('BOX#', '').trim(),
                quantity: quantity.trim(),
                date: date.trim(),
                time: time.trim(),
                isUnsealed: sku.endsWith('_U')
            };
        });

        return parsedEntries;
    };

    const handleAddEntry = () => {
        if (scannedData) {
            try {
                const newEntries = parseScannedData(scannedData);
                setEntries([...entries, ...newEntries]);
                setScannedData('');
            } catch (error) {
                alert(error.message);
            }
        }
    };

    const validatePairs = (entries) => {
        const pairs = [];
    
        for (let i = 0; i < entries.length; i += 2) {
            const unsealed = entries[i];
            const sealed = entries[i + 1];
    
            if (unsealed.isUnsealed && !sealed.isUnsealed && 
                unsealed.sku.replace('_U', '') === sealed.sku) {
                pairs.push({ unsealed, sealed });
            }
        }
    
        return pairs;
    };    

    const handleSave = async () => {
        const validPairs = validatePairs(entries);
        if (validPairs.length === 0) {
            setPopupMessage('No valid pairs found.');
            setShowPopup(true);
            return;
        }
    
        // Логируем данные перед отправкой
        validPairs.forEach(({ unsealed, sealed }, index) => {
            console.log(`Pair ${index + 1}:`);
            console.log('Unsealed Entry:', unsealed);
            console.log('Sealed Entry:', sealed);
        });
    
        try {
            const response = await api.post(`/api/transfer-unsealed-to-sealed`, { entries: validPairs.flat() });
            if (response.status === 200) {
                setPopupMessage('Success! Data transferred.');
            } else {
                setPopupMessage(response.data.error);
            }
            setEntries([]);
        } catch (error) {
            setPopupMessage(`Error: ${error.response?.data?.error || 'Failed to transfer data.'}`);
            console.error('Save error:', error);
        } finally {
            setShowPopup(true);
            setTimeout(() => setShowPopup(false), 3000);
        }
    };
    
    

    return (
        <div className="scanners-inv-seeds-page-bg">
            <HeaderLogged />
            <Container>
            <div className="scan-sealed-sets">
                    <h1 className="scan-sealed-sets-h">Transfer Unsealed to Sealed</h1>
                    <ol className = "entries-list">
                        <li>Step 1 - Scan unsealed label.</li>
                        <li>Step 2 - Scan sealed label.</li>
                        <li>Step 3 - Click format data button.</li>
                        <li>Step 4 - Click Save button.</li>
                    </ol>
                    <textarea
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        placeholder="Scan QR code from 'unsealed' label, then scan QR code from 'sealed' label"
                        className = "scanned-input"
                    ></textarea>
                    <button onClick={handleAddEntry} className = "add-entry-btn">Format Data</button>
                    <ul className = "entries-list"> 
                        {entries.map((entry, index) => (
                            <li key={index}>{entry.sku} - {entry.boxNumber}</li>
                        ))}
                    </ul>
                    <button onClick={handleSave} className = "save-btn">Save</button>
                    {showPopup && <div>{popupMessage}</div>}
                </div>
            </Container>


            <style jsx>{`
                .scan-sealed-sets {
                margin-top: 150px;
                z-index: 1;
                    position: relative;
                }
                .scan-sealed-sets-h {
                margin-bottom: 20px;
                color: #404340;
                text-transform: uppercase;
                font-weight: bold;
                }
                .scanned-input {
                    width: 100%;
                    height: 100px;
                    padding: 10px;
                    border: 1px solid #4caf50;
                    border-radius: 5px;
                    margin-bottom: 10px;  
                }

                .add-entry-btn, .save-btn {
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-top: 10px;
                }

                .add-entry-btn:hover, .save-btn:hover {
                    background-color: #45a049;
                }

                .entries-list {
                    margin-top: 10px;
                    list-style-type: none;
                    padding: 0;
                }

                .entries-list li {
                    background-color: #e8f5e9;
                    padding: 10px;
                    border: 1px solid #c8e6c9;
                    border-radius: 5px;
                    margin-bottom: 5px;
                }

            `}</style>
        </div>

        
    );
};

export default TransferUnsealedToSealed;
